import React, { createContext, useContext } from "react";
import type { CurrentEntityContextType, CurrentEntityProviderProps } from "@/types/contexts/currentEntity";

const CurrentEntityContext = createContext<CurrentEntityContextType | null>(null);

export function CurrentEntityProvider({ children, title, panel, id }: CurrentEntityProviderProps) {
  const contextValue: CurrentEntityContextType = {
    currentTitle: title,
    currentPanel: panel,
    currentId: id,
  };

  return <CurrentEntityContext.Provider value={contextValue}>{children}</CurrentEntityContext.Provider>;
}

export function useCurrentEntity(): CurrentEntityContextType | null {
  return useContext(CurrentEntityContext);
}
